import { NavLink } from 'react-router-dom';
import styles from './styles.module.scss';
import classNames from 'classnames';

export default function NavigateApplication() {
  return (
    <div className={styles.container}>
      <NavLink
        to={'/'}
        className={({ isActive }) => classNames(styles.link, { [styles.active]: isActive })}
      >
        Без залога
      </NavLink>
      <NavLink
        to={'/collateral'}
        className={({ isActive }) => (isActive ? `${styles.link} ${styles.active}` : styles.link)}
      >
        Под залог золота
      </NavLink>
    </div>
  );
}
